import { setLoading } from "../../feature/authSlice"
import { apiConstants } from "../apiConstant"
import { serviceCallIdentity } from "../serviceCall"

export const getAllRolesApi = (callback, errorCallBack) => {
  return async (dispatch) => {
    dispatch(setLoading(true))
    serviceCallIdentity({
      url: apiConstants.AUTH.GET_ALL_ROLES,
      method: 'get',
    })
      .then((response) => {
        dispatch(setLoading(false))
        callback && callback(response)
      })
      .catch((error) => {
        dispatch(setLoading(false))
        errorCallBack && errorCallBack(error.response)
      })
  }
}
